import React from "react";

function Chapter01() {
  return (
    <>
      <div className="chapter-container">

        <h1 className="chapter-title">A4H PAC Southern California Chapter</h1>

        <h3 className="leader">President: Neeraj Kashalkar</h3>

<h3 className="leader">Vice President: Geeta Sikand</h3>

        <h4 className="section-title">About the Chapter</h4>

        <p>
          The A4H PAC Southern California Chapter is a proud branch of Americans4Hindus PAC,
          dedicated to strengthening Hindu political representation and ensuring
          that Hindu-American voices are heard at every level of governance.
        </p>

        <p>Our chapter works tirelessly to:</p>

        <ul>
          <li>Build awareness of civic responsibilities among Hindu-Americans.</li>
          <li>Encourage active participation in local, state, and national politics.</li>
          <li>Support leaders and candidates who uphold Hindu values of dharma, equality, and unity.</li>
          <li>Create a platform for dialogue, collaboration, and community advancement.</li>
        </ul>

        <p>
          Together, we are shaping a future where the Hindu community plays a
          meaningful role in America’s political landscape.
        </p>

        <h4 className="section-title">Our Mission</h4>

        <p>
          Our mission is to empower Hindu-Americans in Southern California to engage
          meaningfully in civic and political life not only as voters, but as
          leaders, policymakers, and changemakers.
        </p>

        <p>
          Through community mobilization, policy education, and leadership
          development, A4H PAC Southern California Chapter seeks to:
        </p>

        <ul>
          <li>Support Hindu candidates running for public office.</li>
          <li>Advocate for issues important to the Hindu community.</li>
          <li>Educate members about local and national political processes.</li>
          <li>Build alliances with other faith and cultural organizations to promote unity.</li>
        </ul>

        <p>
          We believe that when Hindus participate in politics, America becomes
          stronger, more inclusive, and more just.
        </p>

        <h4 className="section-title">Events & Activities</h4>

        <p>Our chapter regularly organizes:</p>

        <ul>
          <li>Town halls and political forums with elected officials and candidates.</li>
          <li>Leadership development workshops to prepare young Hindu-Americans for public service.</li>
          <li>Community service drives highlighting Hindu values of seva (selfless service).</li>
          <li>Fundraising galas and policy discussions in support of the A4H PAC mission.</li>
        </ul>

        <p>
          Upcoming events will be updated here periodically.
        </p>

        <p>
          We welcome all Hindu-Americans in Southern California to become active members of our movement.
        </p>

        <p>
          Your participation helps us expand our reach, advocate effectively, and support Hindu leaders in public life.
        </p>

      </div>

      <style>{`

        .chapter-container{
  width:100%;
  padding:40px 80px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  font-family: Arial, Helvetica, sans-serif;
  line-height:1.6;
  box-sizing:border-box;
}
.chapter-title{
  text-align:center;
  color:#c4002f;
  font-size:32px;
  margin-bottom:60px;
  font-weight:bold;
  width:100%;
}

        .leader{
  font-size:22px;
  font-weight:bold;
  color:#0b3d6d;
  margin-bottom:8px;
  text-transform:uppercase;
}

        .advisor{
          font-size:18px;
          margin-bottom:25px;
        }

        .section-title{
          margin-top:25px;
          font-weight:bold;
        }

        ul{
          margin-left:20px;
        }

        li{
          margin-bottom:5px;
        }

        a{
          color:blue;
        }

      `}</style>
    </>
  );
}

export default Chapter01;